<app-breadcrumb  [parentName]="'Korporacja'" [name]="'Lista'" ></app-breadcrumb>
<div class="support-list-container">

  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="ofwca-list-filters">
    <app-dict
      [dictType]="'type_of_activity_corporation'" [label]="'Rodzaj aktywności '"
      class="support-list-filter"
      [(ngModel)]="initialFilters.typeOfActivity" name="typeOfActivity"
    ></app-dict>

    <app-dict
      [dictType]="'support_status'" [label]="' Status'"
      class="support-list-filter"
      [(ngModel)]="initialFilters.status" name="status"
    ></app-dict>

    <app-dict-partners
      [multiple]="false" [label]="'Partner'"
      class="support-list-filter"
      [(ngModel)]="initialFilters.partner" name="partner"
    ></app-dict-partners>

    <app-dict-ofwcas [multiple]="false"
                     label="OFWCA" class="support-list-filter"
                     [(ngModel)]="initialFilters.ofwca"
                     name="ofwca"
    ></app-dict-ofwcas>

    <app-datepicker
      class="support-list-filter"
      label="Data utworzenia od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
    ></app-datepicker>

    <mat-form-field class="support-list-filter">
      <mat-label>Użytkownik</mat-label>
      <input matInput placeholder="JanKow123" name="username" [(ngModel)]="initialFilters.username">
    </mat-form-field>

    <mat-form-field class="support-list-filter">
      <mat-label>Dane klienta</mat-label>
      <input matInput placeholder="Jan" name="reasonForRefusal" [(ngModel)]="initialFilters.reasonForRefusal">
    </mat-form-field>

    <mat-form-field class="support-list-filter">
      <mat-label>Numer polisy</mat-label>
      <input matInput name="contains$policyNumber" [(ngModel)]="initialFilters.contains$policyNumber">
    </mat-form-field>

  </form>

  <div class="support-list-buttons">
    <button *ngIf="(userPermissions | async)?.corporation.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async)?.corporation.read_report"
            mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <table mat-table [dataSource]="supports">

    <!-- Position Column -->

    <ng-container matColumnDef="id" >
      <th mat-header-cell  *matHeaderCellDef> ID</th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/korporacja/szczegoly', element.uuid]"> {{element.recordId}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="partner/ofwca">
      <th mat-header-cell *matHeaderCellDef> Osoba zgłaszająca </th>
      <td mat-cell *matCellDef="let element">
        {{element.clientType?.name}}
      </td>
    </ng-container>
    <ng-container matColumnDef="partner">
      <th mat-header-cell *matHeaderCellDef> Partner  </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.partner">
          <a class="default-link" [routerLink]="['/partnerzy/szczegoly', element.partner?.uuid]">{{element.partner?.shortName}}</a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="ofwca">
      <th mat-header-cell *matHeaderCellDef> Ofwca </th>
      <td mat-cell *matCellDef="let element">

        <ng-container *ngIf="element.ofwca">
          <a class="default-link" [routerLink]="['/ofwca/szczegoly', element.ofwca?.uuid]">{{element.ofwca.fullName}}</a>
        </ng-container>      </td>
    </ng-container>

    <ng-container matColumnDef="productType">
      <th mat-header-cell *matHeaderCellDef> Produkt </th>
      <td mat-cell *matCellDef="let element">
        {{element.productType?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef> Data utworzenia</th>
      <td mat-cell *matCellDef="let element">
        {{element.createdAt | date:'y-MM-dd HH:mm'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="reasonForRefusal">
      <th mat-header-cell *matHeaderCellDef> Nazwa Klienta </th>
      <td mat-cell *matCellDef="let element">
        {{element.reasonForRefusal}}
      </td>
    </ng-container>

    <ng-container matColumnDef="user">
      <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
      <td mat-cell *matCellDef="let element">
        {{element.createdBy?.username}}
      </td>
    </ng-container>

    <ng-container matColumnDef="policyNumber">
      <th mat-header-cell *matHeaderCellDef> Numer polisy </th>
      <td mat-cell *matCellDef="let element">
        {{element.policyNumber ? element.policyNumber : ''}}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button [ngClass]="element.status.color + '-button'">{{element.status.name}}</button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
